import React, { useEffect, useState } from "react";
import Container from "../../../../components/Container";
import { Grid } from "@mui/material";
import CustomForm from "@sistemas.mundo/custom-form";
import "./configuracion.scss";
import Tarjeta from "./components/Tarjeta/Tarjeta";
import {
  apiObtenerCredenciales,
} from "../../../../service/Configuracion/apiRequest";
import { useUsuario } from "../../../../context/usuarioContext";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/loadingContext";
import ListaContratos from "../../../plan/components/ListaContratos";
import { useNavigate } from "react-router-dom";
import useCambioCredenciales from "../../../../queries/configuracion/useCambioCredenciales";
import { toast } from "react-toastify";
import useApagaRed from "../../../../queries/configuracion/useApagarRed";
import useListarDispos from "../../../../queries/configuracion/useListarDispos";

const Configuracion = () => {
  const navigate = useNavigate();
  const apiCambioContrato = useCambioCredenciales();
  const apiApagarRed = useApagaRed();
  const apiListarDispositivos = useListarDispos();
  const { setLoading, removeLoading } = useLoading();
  const { contratoSeleccionado } = useUsuario();
  const [credencialesRed, setCredencialesRed] = useState(null);

  const [cambiarNombre, setCambiarNombre] = useState(false);
  const [verPass, setVerPass] = useState(false); //Abre la opcion
  const [cambiarPass, setCambiarPass] = useState(false);
  const [verClave, setVerClave] = useState(false); //muestra la clave
  const [configurarDispos, setconfigurarDispos] = useState(false);
  const [verDispositivos, setVerDispositivos] = useState(false);
  const [disposConectados, setDisposConectados] = useState(null);
  const [cambioNombrePass, setCambioNombrePass] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [caposTiempo, setCaposTiempo] = useState({
    campo_1: false,
    campo_2: false,
  });

  useEffect(() => {
    if (contratoSeleccionado) {
      if (!contratoSeleccionado.configurar_wifi) {
        navigate("/");
      }
      setCambiarNombre(false);
      setVerPass(false);
      setCambiarPass(false);
      setVerClave(false);
      setconfigurarDispos(false);
      setVerDispositivos(false);
      setCambioNombrePass(false);
      setLoading({
        id: "credenciales",
        message: "Cargando...",
      });
      apiObtenerCredenciales({
        cont_id: contratoSeleccionado.id_contrato,
      }).then((response) => {
        setCredencialesRed(response.success.descripcionRespuesta);
        removeLoading({ id: "credenciales" });
      });
    }
  }, [contratoSeleccionado]);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  const [listaDispos, setListaDispos] = useState(null);
  useEffect(() => {
    if (verDispositivos) {

      apiListarDispositivos.mutate({ cont_id: contratoSeleccionado.id_contrato })
      /* apiListarDispositivos({ cont_id: contratoSeleccionado.id_contrato }).then(
        (response) => {
          if (response.success) {
            setListaDispos(response.success.descripcionRespuesta);
          }
       
        }
      ); */
    }
  }, [verDispositivos]);

  useEffect(() => {
    if (apiListarDispositivos.isSuccess) {
      setListaDispos(apiListarDispositivos.data.success.descripcionRespuesta);
    }
  }, [apiListarDispositivos.isSuccess])


  const isAsciiText = (text) => {
    for (let i = 0; i < text.length; i++) {
      if (text.charCodeAt(i) > 127) {
        Swal.fire({
          icon: "warning",
          title: "Formato incorrecto",
          html: `<p>El texto ingresado contiene caracteres no permitidos. Por favor, use solo letras y números sin acentos ni símbolos especiales.</p>`,
          confirmButtonText: "Volver",
          focusConfirm: false,
          iconColor: "#facea8",
          width: "40rem",
          customClass: {
            popup: "containerSwal",
            title: "titleSwal",
            closeButton: "...",
            icon: "iconSwal",
            confirmButton: "buttonSwal",
            denyButton: "...",
            cancelButton: "...",
          },
        });
        return {
          value: text,
          isValid: false,
        };
      }
    }
    return {
      value: text,
      isValid: true,
    };
  };

  const onSubmitCambioRed = async (data) => {
    setLoading({
      id: "cambioRed",
      message: "Por favor espere...",
    });

    const result = await apiCambioContrato.mutateAsync({
      cont_id: contratoSeleccionado.id_contrato,
      nombre_red: data.nombre_red ?? null,
      clave_red: data.clave_red ?? null,
    });

    setCambiarPass(false);
    setCambiarNombre(false);
    setVerPass(false);
    setVerClave(false);

    apiObtenerCredenciales({
      cont_id: contratoSeleccionado.id_contrato,
    }).then((response) => {
      setCredencialesRed(response.success.descripcionRespuesta);
    });

    Swal.fire({
      icon: "success",
      title: data.nombre_red
        ? "Tu nombre de red fue actualizado con éxito"
        : "Tu clave WIFI fue actualizada con éxito",
      html: `<p></p>`,
      confirmButtonText: "Volver",
      focusConfirm: false,
      iconColor: "green",
      width: "40rem",
      allowOutsideClick: false,
      customClass: {
        popup: "containerSwal",
        title: "titleSwal",
        closeButton: "...",
        icon: "iconSwal",
        confirmButton: "buttonSwal",
        denyButton: "...",
        cancelButton: "...",
      },
    });
  };

  const onSubmitApagarRed = async (data) => {
    if (!data.campo_10 && !data.campo_15) {
      toast.error("Selecciona una opción");
      return;
    }

    const params = {
      cont_id: contratoSeleccionado.id_contrato,
      enable: 0,
      minutes: data.campo_10 ? 10 : 15,
    };

    await apiApagarRed.mutateAsync(params);

    setCambiarPass(false);
    setCambiarNombre(false);
    setconfigurarDispos(false);
    setCaposTiempo({ campo_1: false, campo_2: false });

    apiObtenerCredenciales({
      cont_id: contratoSeleccionado.id_contrato,
    }).then((response) => {
      setCredencialesRed(response.success.descripcionRespuesta);
    });

    Swal.fire({
      icon: "success",
      title: `Tu red fue apagada por ${data.campo_10 ? "10" : "15"
        } minutos con éxito`,
      confirmButtonText: "Volver",
      focusConfirm: false,
      iconColor: "green",
      width: "40rem",
      allowOutsideClick: false,
      customClass: {
        popup: "containerSwal",
        title: "titleSwal",
        closeButton: "...",
        icon: "iconSwal",
        confirmButton: "buttonSwal",
        denyButton: "...",
        cancelButton: "...",
      },
    });
  };

  const camposCambioName = () => {
    return [
      {
        title: "",
        elements: [
          {
            name: "nombre_red",
            label: "Nombre",
            placeholder: "Nuevo Nombre de Red",
            value: null,
            type: "text",
            minLength: 3,
            maxLength: 20,
            required: true,
            customValidation: isAsciiText,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
        ],
      },
    ];
  };

  const verClaveWifi = () => {
    return [
      {
        title: "",
        elements: [
          {
            name: "name",
            placeholder: "Nuevo Nombre de Red",
            value: "********",
            type: "text",
            disabled: true,
            visible: !verClave,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },

          {
            name: "name2",
            placeholder: "Sin clave",
            value: credencialesRed?.clave_red ?? null,
            type: "text",
            disabled: true,
            visible: verClave,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
        ],
      },
    ];
  };

  const nuevaPass = () => {
    return [
      {
        title: "",
        elements: [
          {
            name: "clave_red",
            label: "Contraseña",
            placeholder: "Nueva contraseña",
            value: null,
            type: "password",
            customValidation: isAsciiText,
            minLength: 8,
            maxLength: 20,
            required: true,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
          {
            name: "pass2",
            label: "Confirmar Contraseña",
            placeholder: "Confirmar Nueva contraseña",
            value: null,
            type: "password",
            required: true,
            customValidation: (e) => {
              const form = document.getElementById("cambio_pass_gestion_red");
              const x = form.querySelector("#clave_red");
              if (x.value == e) {
                return {
                  message: "",
                  isValid: true,
                };
              }
              return {
                message: "Las contraseñas no coinciden",
                isValid: false,
              };
            },
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
        ],
      },
    ];
  };

  const tiempoApagado = () => {
    return [
      {
        title: "",
        elements: [
          {
            name: "campo_10",
            descripcion: "Desactivar Red 5 GHz por 10 minutos",
            value: caposTiempo.campo_1,
            onChange: (e) => {
              setCaposTiempo({ campo_1: e, campo_2: false });
            },
            type: "checkbox",
            disabled: caposTiempo.campo_2,
            control: true,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
          {
            name: "campo_15",
            descripcion: "Desactivar Red 5 GHz por 15 minutos",
            value: caposTiempo.campo_2,
            disabled: caposTiempo.campo_1,
            onChange: (e) => {
              setCaposTiempo({ campo_1: false, campo_2: e });
            },
            type: "checkbox",
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
        ],
      },
    ];
  };

  const nuevoNombrePass = () => {
    return [
      {
        title: "",
        elements: [
          {
            name: "nombre_red",
            label: "Nombre",
            placeholder: "Nuevo Nombre de Red",
            value: null,
            type: "text",
            minLength: 3,
            maxLength: 20,
            required: true,
            customValidation: isAsciiText,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
          {
            name: "clave_red",
            label: "Contraseña",
            placeholder: "Nueva contraseña",
            value: null,
            type: "password",
            customValidation: isAsciiText,
            minLength: 8,
            maxLength: 20,
            required: true,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
          {
            name: "pass2",
            label: "Confirmar Contraseña",
            placeholder: "Confirmar Nueva contraseña",
            value: null,
            type: "password",
            required: true,
            customValidation: (e) => {
              const form = document.getElementById("cambio_nombre_pass");
              const x = form.querySelector("#clave_red");
              if (x.value == e) {
                return {
                  message: "",
                  isValid: true,
                };
              }
              return {
                message: "Las contraseñas no coinciden",
                isValid: false,
              };
            },
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
        ],
      },
    ];
  };
  return (
    <>
      <>
        <Container tituloContainer="Cambia tu contraseña y nombre de red" />
        {contratoSeleccionado.unidad_negocio == 1 ||
          contratoSeleccionado.plan.nombre == "Fijo" ? (
          <ListaContratos />
        ) : (
          <div
            className="configuracion-container"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 1, md: 1 }}
              sx={{
                maxWidth: {
                  xs: "100%",
                  sm: "80%",
                },
              }}
            >
              {credencialesRed &&
                (credencialesRed.clave_red == null ||
                  credencialesRed.nombre_red == null) ? (
                <>
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Tarjeta
                      //title1="Configurar"
                      title="Configurar credenciales WiFi"
                      accion={cambioNombrePass ? "Volver" : "Configurar"}
                      info={
                        cambioNombrePass
                          ? null
                          : "Configura tu nombre de red y contraseña de WiFi por primera vez."
                      }
                      onClick={() => setCambioNombrePass(!cambioNombrePass)}
                    >
                      {cambioNombrePass && (
                        <>
                          <ul
                            style={{
                              fontSize: "12px",
                              color: "#404040",
                              textAlign: "justify",
                              paddingLeft: "20px",
                            }}
                          >
                            <li>
                              Tu nombre de red debe ser diferente a tu clave
                              WIFI.
                            </li>
                            <li>
                              {" "}
                              El nombre de red debe tener un mínimo de 3
                              caracteres y un máximo de 20 caracteres.
                            </li>
                            <li>
                              La contraseña debe tener mínimo 8 caracteres y un
                              máximo de 20 caracteres.{" "}
                            </li>
                            <li>Debes tener tus equipos encendidos.</li>
                            <li>
                              Recuerda que al cambiar tu contraseña o nombre de
                              red, debes volver a conectarte a la red en tus
                              dispositivos.
                            </li>
                          </ul>

                          <CustomForm
                            formId="cambio_nombre_pass"
                            campos={nuevoNombrePass()}
                            showClearForm={false}
                            onSubmit={onSubmitCambioRed}
                            submitButtonText={"CONFIGURAR"}
                            tooltipSubmitBtn={"CONFIGURAR "}
                            submitButtonPosition="center"
                            fullButtonSubmitWidth={true}
                            resetCamposOnSubmit={false}
                          />
                        </>
                      )}
                    </Tarjeta>
                  </Grid>
                </>
              ) : (
                <>
                  {" "}
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Tarjeta
                      //title1="Cambiar"
                      title="Nombre de Red"
                      accion={cambiarNombre ? "Volver" : "Cambiar"}
                      credenciales={cambiarNombre ? credencialesRed : null}
                      info={
                        cambiarNombre
                          ? "Nombre de Red Actual: "
                          : "Cambia el nombre (SSID) actual de tu red WiFi 2.4 GHz y 5GHz."
                      }
                      onClick={() => setCambiarNombre(!cambiarNombre)}
                    >
                      {cambiarNombre && (
                        <>
                          <ul
                            style={{
                              fontSize: "12px",
                              color: "#404040",
                              textAlign: "justify",
                              paddingLeft: "20px",
                            }}
                          >
                            <li>
                              Tu nombre de red debe ser diferente a tu clave
                              WIFI.
                            </li>
                            <li>
                              {" "}
                              El nombre de red debe tener un mínimo de 3
                              caracteres y un máximo de 20 caracteres.
                            </li>
                            <li>Debes tener tus equipos encendidos.</li>
                            <li>
                              Recuerda que al cambiar tu contraseña o nombre de
                              red, deberás volver a conectarte a la red en tus
                              dispositivos
                            </li>
                          </ul>

                          <CustomForm
                            formId="cambio_pass_correo"
                            campos={camposCambioName()}
                            showClearForm={false}
                            onSubmit={onSubmitCambioRed}
                            submitButtonText={"CAMBIAR"}
                            tooltipSubmitBtn={"CAMBIAR "}
                            submitButtonPosition="center"
                            fullButtonSubmitWidth={true}
                            resetCamposOnSubmit={false}
                          />
                        </>
                      )}
                    </Tarjeta>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Tarjeta
                      //title1="Ver"
                      accion={verPass ? "Volver" : "Ver"}
                      title="Ver Clave WIFI"
                      info={
                        verPass
                          ? "Contraseña Actual"
                          : "Visualiza tu contraseña actual para acceder a la red WiFi."
                      }
                      onClick={() => {
                        setVerPass(!verPass);
                        setVerClave(verPass);
                      }}
                    >
                      {verPass && (
                        <CustomForm
                          campos={verClaveWifi()}
                          showClearForm={false}
                          onSubmit={() => setVerClave(true)}
                          submitButtonText={"VER"}
                          tooltipSubmitBtn={"VER"}
                          submitButtonPosition="center"
                          fullButtonSubmitWidth={true}
                          resetCamposOnSubmit={false}
                        />
                      )}
                    </Tarjeta>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Tarjeta
                      //title1="Cambiar"
                      accion={cambiarPass ? "Volver" : "Cambiar"}
                      title="Cambiar Clave WIFI"
                      info={
                        cambiarPass
                          ? "Cambiar tu clave de WiFi"
                          : "Ingresa tu nueva contraseña para acceder a la red WiFi."
                      }
                      onClick={() => setCambiarPass(!cambiarPass)}
                    >
                      {cambiarPass && (
                        <>
                          <ul
                            style={{
                              fontSize: "12px",
                              color: "#404040",
                              textAlign: "justify",
                              paddingLeft: "20px",
                            }}
                          >
                            <li>
                              La contraseña debe tener mínimo 8 caracteres y un
                              máximo de 20 caracteres.
                            </li>
                            <li>
                              Te recomendamos usar letras mayúsculas y
                              minúsculas.
                            </li>
                            <li>Debes tener tus equipos encendidos.</li>
                            <li>
                              Recuerda que al cambiar tu contraseña o nombre de
                              red, deberás volver a conectarte a la red en tus
                              dispositivos.
                            </li>
                          </ul>

                          <CustomForm
                            formId="cambio_pass_gestion_red"
                            campos={nuevaPass()}
                            showClearForm={false}
                            onSubmit={onSubmitCambioRed}
                            submitButtonText={"CAMBIAR"}
                            tooltipSubmitBtn={"CAMBIAR "}
                            submitButtonPosition="center"
                            fullButtonSubmitWidth={true}
                            resetCamposOnSubmit={false}
                          />
                        </>
                      )}
                    </Tarjeta>
                  </Grid>
                </>
              )}

              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Tarjeta
                  //title1="Configura tus"
                  accion={!configurarDispos ? "Configurar" : "Volver"}
                  title="Configura tus Dispositivos Inteligentes"
                  info={
                    !configurarDispos
                      ? "Apaga la red 5 GHz. Durante este tiempo, tus dispositivos se conectarán a la red 2.4 GHz."
                      : "Elige por cuánto tiempo deseas desactivar tu red 5 GHz."
                  }
                  onClick={() => setconfigurarDispos(!configurarDispos)}
                >
                  {configurarDispos && (
                    <>
                      <h2
                        style={{
                          fontSize: "14px",
                          color: "#00657D",
                          textAlign: "justify",
                        }}
                      >
                        Al finalizar el tiempo seleccionado, la red se
                        reactivará automáticamente.
                      </h2>
                      <CustomForm
                        formId="configurar_red"
                        campos={tiempoApagado()}
                        showClearForm={false}
                        onSubmit={onSubmitApagarRed}
                        submitButtonText={"Desactivar"}
                        tooltipSubmitBtn={"Desactivar "}
                        submitButtonPosition="center"
                        fullButtonSubmitWidth={true}
                        resetCamposOnSubmit={false}
                      />
                    </>
                  )}
                </Tarjeta>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Tarjeta
                  //title1="Dispositivos"
                  accion={!verDispositivos ? "Ver" : "Volver"}
                  title="Dispositivos Conectados"
                  info={
                    !verDispositivos
                      ? "Visualiza los dispositivos conectados a tu red."
                      : "A continuación, se muestra la lista de dispositivos conectados a tu red."
                  }
                  onClick={() => setVerDispositivos(!verDispositivos)}
                >
                  {verDispositivos && listaDispos && (
                    <>
                      <div>
                      {listaDispos.length == 0 && <div><h2
                          style={{
                            fontSize: "14px",
                            color: "#00657D",
                            textAlign: "justify",
                          }}
                        >
                          No tiene dispositivos conectados
                        </h2></div>}
                        {Object.keys(listaDispos).map((network) => {
                          const networkName =
                            network.toLowerCase() === "red 1"
                              ? "Red 2.4Ghz"
                              : network.toLowerCase() === "red 5"
                                ? "Red 5Ghz"
                                : network;

                          return (
                            <div key={network}>
                              <h2
                                style={{
                                  fontSize: "14px",
                                  color: "#00657D",
                                  textAlign: "justify",
                                }}
                              >
                                {networkName}
                              </h2>
                              <ul
                                style={{
                                  fontSize: "12px",
                                  color: "#404040",
                                  //textAlign: "justify",
                                  //paddingLeft: "20px",
                                }}
                              >
                                {listaDispos[network].map((device, index) => (
                                  <li key={index}>
                                  <b>Nombre:</b>{" " + device.hostname} 
                                  <br/>
                                  <b>MAC:</b>{" " +device.macDevice} 
                                  <br />
                                  <b>IP:</b>{" "+device.ipDevice}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </Tarjeta>
              </Grid>
            </Grid>
          </div>
        )}
      </>
    </>
  );
};

export default Configuracion;
